import React, { Component } from "react";
import styled, { css } from "react-emotion";
import { subscribeNewsLetter } from "apis";
import { H2, P, Button, H1 } from "appStyles";
import { isMobileDevice } from "helpers";

const SubscribeFormStyle = styled("form")`
  bottom: 0;
  border-radius: 5px;
  padding: 1em;
  border: 1px solid #707070;
  box-shadow: 2px 2px 10px #888888;
  position: absolute;
  width: ${(props) => (props.innerWidth ? props.innerWidth : "40em")};
  background: ${(props) => props.background};
  height: 12em;

  @media (max-width: 450px) {
    height: auto;
    text-align: center;
    position: relative;
    width: auto;
  }
`;

const InputBox = styled("input")`
  border: 1px solid #78d2b1;
  padding: 1em;
  font-size: 14px;
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "inherit")};
  width: 55%;
  height: 20%;
  border-radius: 5px;
  position: relative;
  margin-right: 1em;

  &:focus {
    outline: none;
  }

  @media (max-width: 450px) {
    margin-bottom: 1em;
    width: 100%;
    height: 40px;
  }
`;

const inputGroup = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-items: center;
  margin-left: 1em;
  width: 100%;

  @media (max-width: 450px) {
    display: flex;
    flex-direction: column;
    padding: 1em;
  }
`;

const bottomPart = css`
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;
  margin: 1.5em 0 1em 0;

  @media (max-width: 450px) {
    margin: 1.5em 0 0 0;
  }
`;

const smallImage = css`
  height: 60px;
  width: 54px;
`;

const subscribedNote = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
`;

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

class SubscribeForm extends Component {
  state = {
    email: "",
    firstName: "",
    lastName: "",
    subscribed: false,
  };

  submit = (e) => {
    e.preventDefault();
    const { firstName, lastName, email } = this.state;

    if (validateEmail(email)) {
      subscribeNewsLetter(firstName, lastName, email).then((subscribed) => {
        if (subscribed) this.props.subscribeStatus();
      });
    } else {
      alert("Please enter valid email!");
    }
  };

  update = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  render() {
    const { email, firstName, lastName } = this.state;
    const {
      subscribed,
      color,
      title,
      envelope,
      buttonColor,
      buttonText,
      description,
      titleFontFamily,
      descriptionFontFamily,
      formFontFamily,
    } = this.props;

    return (
      <div
        style={{
          position: this.props.position,
          bottom: this.props.bottom,
          width: this.props.width,
          zIndex: this.props.zIndex,
        }}
      >
        <SubscribeFormStyle {...this.props} onSubmit={this.submit}>
          {subscribed ? (
            <div className={subscribedNote}>
              <H1 margin="0 0 1em 0" color={color}>
                Thank You!
              </H1>
              <P color={color}>We will contact you soon!</P>
            </div>
          ) : (
            <React.Fragment>
              <H2 color={color} fontFamily={titleFontFamily}>
                {title}
              </H2>
              <P
                color={color}
                marginTop="1em"
                width={isMobileDevice() ? "auto" : "70%"}
                fontFamily={descriptionFontFamily}
                fontSize="0.9em"
              >
                {description}
              </P>
              <div className={bottomPart}>
                {envelope && (
                  <img
                    className={smallImage}
                    src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/envelop.png"
                  />
                )}
                <div className={inputGroup}>
                  <InputBox
                    fontFamily={formFontFamily}
                    placeholder="First Name"
                    onChange={this.update}
                    name="firstName"
                    type="text"
                    value={firstName}
                  />
                  <InputBox
                    fontFamily={formFontFamily}
                    placeholder="Last Name"
                    onChange={this.update}
                    name="lastName"
                    type="text"
                    value={lastName}
                  />
                  <InputBox
                    fontFamily={formFontFamily}
                    placeholder="Email"
                    onChange={this.update}
                    name="email"
                    type="text"
                    value={email}
                  />
                  <Button
                    width="200px"
                    height="40px"
                    fontFamily={formFontFamily}
                    background={buttonColor}
                    onClick={this.submit}
                  >
                    {buttonText}
                  </Button>
                </div>
              </div>
            </React.Fragment>
          )}
        </SubscribeFormStyle>
      </div>
    );
  }
}

export default SubscribeForm;
